import { Controller } from "@hotwired/stimulus"

// Shows the "In foster" checkbox only while the selected status is one a dog
// can be fostered in, and unticks it otherwise. Dog#in_foster is also cleared
// server-side, so this just keeps the form honest.
export default class extends Controller {
  static targets = ["status", "field", "checkbox"]
  static values = { statuses: Array }

  toggle() {
    const fosterable = this.statusesValue.includes(this.statusTarget.value)
    this.fieldTarget.hidden = !fosterable
    if (!fosterable) this.checkboxTarget.checked = false
  }
}
